/**
 * Chrome major version at or above which a client is treated as a current,
 * real browser. Chrome 100 shipped in March 2022 and Chrome auto-updates, so a
 * sub-100 Chrome major in production is effectively only reached by crawlers and
 * abandoned or spoofed user agents, not real users.
 */
const MODERN_CHROME_MAJOR = 100;

/**
 * Heuristic for "this client is almost certainly an automated bot or an
 * abandoned browser rather than a real user". Two independent signals:
 *  - an automation flag (`navigator.webdriver`), or
 *  - a Chrome/Chromium user agent reporting a major below `MODERN_CHROME_MAJOR`.
 *
 * Router-boundary errors from such clients are not actionable real-user RR7
 * bugs, so callers log them below `error`. Non-Chrome user agents (Safari,
 * Firefox) are never flagged on the version signal. The user agent and
 * automation flag are passed in rather than read from `navigator` so the rule
 * stays pure and unit-testable.
 */
export const isLikelyBotOrOutdatedClient = (
    userAgent: string,
    isWebDriver = false,
): boolean => {
    if (isWebDriver) {
        return true;
    }
    const chromeMajor = /Chrome\/(\d+)/.exec(userAgent)?.[1];
    return (
        chromeMajor !== undefined && Number(chromeMajor) < MODERN_CHROME_MAJOR
    );
};
